export const useParams = (search) => {
  const params = search.substring(1)
  try {
    return JSON.parse('{"' + params.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value) })
  } catch (e) {
    return {}
  }
}

export const getUrlParam = (search, param) => {
  const searchParams = new URLSearchParams(search)
  return searchParams.get(param)
}



// WEBPACK FOOTER //
// ./src/utilities/url.js